import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import React from 'react';
import isObject from "lodash/isObject";
import isArray from "lodash/isArray";
import isString from "lodash/isString";
import omitBy from "lodash/omitBy";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";
import get from "lodash/get";
import { log, makeUniqueWarningLog } from '@jutro/logger';
import { ResponsiveElement, IntlElement } from '@jutro/components';
import { isSupportedHTMLElement, isSupportedHTMLContainer, iterateMetadata, SchemaValidator, metadataSchema, resolveContentReference } from '@jutro/uimetadata';
import { removeDangerousProps } from '@jutro/platform';
import { resolveComponentFromDatatype, resolveComponentFromName } from './componentMap';
import { UnresolvedComponent } from './UnresolvedComponent/UnresolvedComponent';
const schemaValidator = new SchemaValidator(metadataSchema);
const callbackRegex = /^(on|render)[A-Z]/;
const classNameRegex = /^className$|\w+ClassName$/;
export function resolveCallbackProps(props, callbackMap) {
  return resolvePropsWithMap(props, callbackMap, isValidCallbackProp, resolveCallback);
}
export function resolveClassNamesProps(props, classNameMap) {
  return resolvePropsWithMap(props, classNameMap, isValidClassNameProp, resolveClassNames);
}
export function resolveProps(props, callbackMap, classNameMap) {
  return resolveCallbackProps(resolveClassNamesProps(props, classNameMap), callbackMap);
}
const resolvePropsWithMap = (props, map, matcher, resolver) => {
  var _context;
  return _reduceInstanceProperty(_context = _Object$keys(props)).call(_context, (result, key) => {
    const originalValue = props[key],
      id = props.id;
    const newValue = matcher(key, originalValue) ? resolver(id, originalValue, map) : originalValue;
    return _objectSpread({}, result, {
      [key]: newValue
    });
  }, {});
};
function isValidCallbackProp(callbackProp, callbackValue) {
  if (!callbackProp.match(callbackRegex)) return false;
  if (!callbackValue) return false;
  return isString(callbackValue) || isObject(callbackValue) && callbackValue.callback;
}
function isValidClassNameProp(classNameProp, classNameValue) {
  if (!classNameProp.match(classNameRegex)) return false;
  if (!classNameValue) return false;
  return isString(classNameValue);
}
function mapLookup(map, key, defaultValue = undefined) {
  if (!key) {
    return undefined;
  }
  return map && map[key] || defaultValue;
}
export function resolveClassName(id, className, classNameMap) {
  return mapLookup(classNameMap, className, className);
}
export function resolveClassNames(id, classNames, classNameMap, resolver = resolveClassName) {
  const oldNames = classNames.split(' ');
  const newNames = _mapInstanceProperty(oldNames).call(oldNames, className => resolver(id, className, classNameMap));
  return newNames.join(' ');
}
export function resolveCallback(id, callbackName, callbackMap) {
  return mapLookup(callbackMap, callbackName);
}
const deprecationWarningForComponentCasing = makeUniqueWarningLog('Support for componentMaps with case-insensitive keys has been deprecated. Adjust the keys in your componentMap to match the name of the component');
export function resolveComponent(component, datatype, componentMap) {
  if (!component && !datatype) {
    return undefined;
  }
  let componentInfo;
  if (!componentInfo && component && !isString(component)) {
    componentInfo = {
      component
    };
  }
  if (isString(component)) {
    if (!componentInfo && componentMap) {
      componentInfo = mapLookup(componentMap, component);
    }
    if (!componentInfo && componentMap) {
      componentInfo = mapLookup(componentMap, component.toLowerCase());
      if (componentInfo) {
        deprecationWarningForComponentCasing();
      }
    }
    if (!componentInfo) {
      componentInfo = resolveComponentFromName(component);
    }
    if (!componentInfo) {
      componentInfo = {
        component
      };
    }
  }
  if (isString(datatype)) {
    if (!componentInfo && componentMap) {
      componentInfo = mapLookup(componentMap, datatype.toLowerCase());
    }
    if (!componentInfo) {
      componentInfo = resolveComponentFromDatatype(datatype, false);
    }
    if (!componentInfo) {
      log.warning("unable to resolve component by datatype: \"".concat(datatype, "\""));
    }
  }
  return componentInfo;
}
function getContentArray(contentMetadata) {
  if (isArray(contentMetadata)) {
    return contentMetadata;
  }
  if (isObject(contentMetadata) && contentMetadata.content && isArray(contentMetadata.content)) {
    return contentMetadata.content;
  }
  return [];
}
export function prepareComponentFromMetadata(metadata, overrideProps, resolvers = {}, rootMetadata, metadataPath) {
  var _context2;
  if (!metadata) {
    return null;
  }
  if (React.isValidElement(metadata)) {
    return metadata;
  }
  const id = metadata.id,
    type = metadata.type,
    datatype = metadata.datatype,
    component = metadata.component,
    _metadata$componentPr = metadata.componentProps,
    componentProps = _metadata$componentPr === void 0 ? {} : _metadata$componentPr,
    content = metadata.content,
    contentAfter = metadata.contentAfter,
    contentBefore = metadata.contentBefore,
    contentEmpty = metadata.contentEmpty,
    contentRepeat = metadata.contentRepeat,
    contentRepeatAfter = metadata.contentRepeatAfter,
    contentRepeatBefore = metadata.contentRepeatBefore,
    contentLayout = metadata.contentLayout,
    selfLayout = metadata.selfLayout;
  const _prepareOverrides = prepareOverrides(id, type, componentProps.path, overrideProps),
    contentOverride = _prepareOverrides.content,
    propOverrides = _objectWithoutProperties(_prepareOverrides, ["content"]);
  let additionalProps = propOverrides;
  let dataProps;
  let baseDatatype;
  let baseComponent;
  const fieldPath = additionalProps && additionalProps.path || componentProps && componentProps.path;
  const hasDataProps = _includesInstanceProperty(_context2 = ['element', 'field', 'container', 'iterable', 'layout']).call(_context2, type) && fieldPath;
  if (hasDataProps && resolvers.resolveDataProps) {
    const resolvedDataProps = resolvers.resolveDataProps(id, fieldPath);
    if (resolvedDataProps) {
      baseDatatype = resolvedDataProps.datatype;
      baseComponent = resolvedDataProps.component;
      dataProps = resolvedDataProps.componentProps;
    }
  }
  const componentInfo = prepareComponentInfo(component || baseComponent, datatype || baseDatatype, type, content, _objectSpread({}, dataProps, {}, componentProps, {}, additionalProps), resolvers, metadataPath);
  const Component = componentInfo && componentInfo.component;
  const componentMapProps = componentInfo && componentInfo.componentProps;
  if (resolvers.resolveCallbackMap) {
    additionalProps = prepareCallbackOverrides(componentProps, additionalProps);
  }
  const combinedProps = removeDangerousProps(_objectSpread({}, dataProps, {}, componentMapProps, {}, componentProps, {}, additionalProps));
  let children = contentOverride || content;
  let resolvedContent = contentOverride || resolveContent(metadata, resolvers);
  if (type === 'iterable' && contentRepeat && combinedProps.visible !== false) {
    const repeatPath = contentRepeat.path || combinedProps.path;
    const repeatData = contentRepeat.data || combinedProps.data || resolvers.resolveValue && resolvers.resolveValue(id, repeatPath);
    resolvedContent = iterateMetadata({
      contentAfter,
      contentRepeatAfter,
      contentBefore,
      contentRepeatBefore,
      contentEmpty,
      contentRepeat,
      repeatData,
      repeatPath
    });
  }
  let preparedChildrenLayout;
  if (isArray(resolvedContent)) {
    const preparedContent = prepareContentFromMetadata({
      content: resolvedContent,
      contentLayout
    }, overrideProps, resolvers, rootMetadata, metadataPath);
    children = preparedContent.content;
    preparedChildrenLayout = preparedContent.contentLayout;
  }
  if (Component !== undefined) {
    prepareComponentProps(id, type, Component, combinedProps, resolvers);
  }
  const preparedSelfLayout = selfLayout ? prepareLayout(selfLayout, resolvers) : undefined;
  const result = {
    id,
    type,
    datatype,
    component: Component,
    componentProps: !isEmpty(combinedProps) ? combinedProps : undefined,
    content: children,
    contentLayout: preparedChildrenLayout,
    selfLayout: preparedSelfLayout
  };
  return omitBy(result, isUndefined);
}
function prepareLayout(layout, resolvers) {
  const componentInfo = prepareComponentInfo(layout.component, undefined, 'layout', undefined, undefined, resolvers);
  if (resolvers) {
    prepareComponentProps(null, null, layout.component, layout.componentProps, resolvers);
  }
  return _objectSpread({}, layout, {
    componentProps: removeDangerousProps(layout.componentProps),
    component: componentInfo && componentInfo.component
  });
}
function prepareComponentInfo(component, datatype, type, content, componentProps, resolvers, metadataPath) {
  let transformComponentMap;
  if (isString(component) && type === 'element' && isSupportedHTMLElement(component)) {
    const hasIntlContent = content && content.id !== undefined && content.defaultMessage !== undefined;
    const _ref = componentProps || {},
      phone = _ref.phone,
      phoneWide = _ref.phoneWide,
      tablet = _ref.tablet;
    const hasBreakpointProps = phone || phoneWide || tablet;
    if (hasBreakpointProps && hasIntlContent) {
      transformComponentMap = {
        [component]: {
          component: ResponsiveElement,
          componentProps: {
            tag: component,
            parentTag: IntlElement
          }
        }
      };
    } else if (hasIntlContent) {
      transformComponentMap = {
        [component]: {
          component: IntlElement,
          componentProps: {
            tag: component
          }
        }
      };
    } else if (hasBreakpointProps) {
      transformComponentMap = {
        [component]: {
          component: ResponsiveElement,
          componentProps: {
            tag: component
          }
        }
      };
    }
  }
  const componentResolver = resolvers && resolvers.resolveComponent || resolveComponent;
  const componentMap = resolvers && resolvers.resolveComponentMap;
  const componentInfo = componentResolver(component, datatype, transformComponentMap ? _objectSpread({}, transformComponentMap, {}, componentMap) : componentMap, type, metadataPath, componentProps);
  if (componentInfo && !componentInfo.component) {
    return {
      component: componentInfo
    };
  }
  return componentInfo;
}
function prepareOverrides(id, type, path, overrideProps) {
  let additionalProps = {};
  const resolveOverrides = key => {
    const overrides = overrideProps[key];
    return typeof overrides === 'function' ? overrides(id, path) : overrides;
  };
  if (overrideProps && overrideProps['@all']) {
    additionalProps = _objectSpread({}, additionalProps, {}, resolveOverrides('@all'));
  }
  if (overrideProps && overrideProps["@".concat(type)]) {
    additionalProps = _objectSpread({}, additionalProps, {}, resolveOverrides("@".concat(type)));
  }
  if (overrideProps && overrideProps[id]) {
    additionalProps = _objectSpread({}, additionalProps, {}, resolveOverrides(id));
  }
  return additionalProps;
}
function prepareCallbackOverrides(componentProps, additionalProps) {
  const resolvedProps = additionalProps;
  if (componentProps) {
    var _context3;
    _forEachInstanceProperty(_context3 = _Object$keys(componentProps)).call(_context3, callbackProp => {
      const callbackValue = componentProps[callbackProp];
      if (isValidCallbackProp(callbackProp, callbackValue)) {
        resolvedProps[callbackProp] = callbackValue;
      }
    });
  }
  return resolvedProps;
}
function prepareComponentProps(id, type, component, props, resolvers) {
  const componentProps = props;
  const _ref2 = componentProps || {},
    path = _ref2.path,
    startPath = _ref2.startPath,
    endPath = _ref2.endPath;
  const _ref3 = (component === null || component === void 0 ? void 0 : component.defaultProps) || {},
    startPathValueProp = _ref3.startPathValueProp,
    endPathValueProp = _ref3.endPathValueProp;
  if ((type === 'element' || type === 'field') && resolvers.resolveValue) {
    if (path) {
      componentProps.value = resolvers.resolveValue(id, path);
    }
    if (startPath && endPath) {
      componentProps.value = {
        [startPathValueProp]: resolvers.resolveValue("".concat(id, "_").concat(startPathValueProp), startPath),
        [endPathValueProp]: resolvers.resolveValue("".concat(id, "_").concat(endPathValueProp), endPath)
      };
    }
  }
  if ((type === 'container' || type === 'iterable') && path && resolvers.resolveValue) {
    componentProps.data = resolvers.resolveValue(id, path);
  }
  if (type === 'field' && resolvers.resolveDefaultValue) {
    if (path) {
      componentProps.defaultValue = resolvers.resolveDefaultValue(id, path);
    }
    if (startPath && endPath) {
      componentProps.defaultValue = {
        [startPathValueProp]: resolvers.resolveDefaultValue("".concat(id, "_").concat(startPathValueProp), startPath),
        [endPathValueProp]: resolvers.resolveDefaultValue("".concat(id, "_").concat(endPathValueProp), endPath)
      };
    }
  }
  if (resolvers.resolveClassName || resolvers.resolveClassNameMap) {
    const classNameResolver = resolvers.resolveClassName || resolveClassName;
    const classNameMap = resolvers.resolveClassNameMap;
    if (componentProps) {
      var _context4, _context5;
      _forEachInstanceProperty(_context4 = _filterInstanceProperty(_context5 = _Object$keys(componentProps)).call(_context5, prop => isValidClassNameProp(prop, componentProps[prop]))).call(_context4, classNameProp => {
        componentProps[classNameProp] = resolveClassNames(id, componentProps[classNameProp], classNameMap, classNameResolver);
      });
    }
  }
  prepareCallbacksInComponentProps({
    resolvers,
    id,
    componentProps
  });
  if (type === 'field' && resolvers.resolveValidation) {
    componentProps.validationMessages = resolvers.resolveValidation(id, path, componentProps && componentProps.value);
  }
}
export const prepareCallbacksInComponentProps = ({
  resolvers,
  id,
  componentProps
}) => {
  if (resolvers.resolveCallback || resolvers.resolveCallbackMap) {
    const callbackResolver = resolvers.resolveCallback || resolveCallback;
    const callbackMap = resolvers.resolveCallbackMap;
    if (!isEmpty(componentProps)) {
      var _context6;
      const componentPropsWithCallbacks = _filterInstanceProperty(_context6 = _Object$keys(componentProps)).call(_context6, callbackProp => isValidCallbackProp(callbackProp, componentProps[callbackProp]));
      _forEachInstanceProperty(componentPropsWithCallbacks).call(componentPropsWithCallbacks, callbackProp => {
        const callbackValue = componentProps[callbackProp];
        const callbackFunction = callbackResolver(id, get(callbackValue, 'callback', callbackValue), callbackMap);
        if (callbackMap && !callbackFunction) {
          log.warning("unable to resolve callback: ".concat(_JSON$stringify(callbackValue, null, 2)));
        }
        const wrappedFn = callbackValue.callback && callbackFunction ? (...args) => callbackFunction(_objectSpread({}, callbackValue.callbackProps), ...args) : callbackFunction;
        componentProps[callbackProp] = wrappedFn;
      });
      return _objectSpread({}, componentProps);
    }
  }
  return componentProps;
};
export function prepareContentFromMetadata(contentMetadata, overrideProps, resolvers, rootMetadata, metadataPath = '') {
  const contentArray = getContentArray(contentMetadata);
  const content = _mapInstanceProperty(contentArray).call(contentArray, (item, i) => {
    const extendedItem = resolveContentReference(item, rootMetadata);
    return prepareComponentFromMetadata(extendedItem, overrideProps, resolvers, rootMetadata, "".concat(metadataPath ? "".concat(metadataPath, ".") : metadataPath, "content.").concat(i));
  });
  const contentLayoutMetadata = contentMetadata && contentMetadata.contentLayout;
  const contentLayout = contentLayoutMetadata ? prepareLayout(contentLayoutMetadata, resolvers) : undefined;
  return {
    content,
    contentLayout
  };
}
export function renderComponentFromMetadata(metadata, showHidden = false) {
  if (!metadata) {
    return null;
  }
  if (React.isValidElement(metadata)) {
    return metadata;
  }
  const id = metadata.id,
    Component = metadata.component,
    componentProps = metadata.componentProps,
    content = metadata.content,
    contentLayout = metadata.contentLayout,
    selfLayout = metadata.selfLayout;
  const _ref4 = componentProps || {},
    visible = _ref4.visible,
    path = _ref4.path;
  const key = id || path;
  if (!showHidden && visible === false) {
    return null;
  }
  let children;
  if (isArray(content)) {
    children = renderContent(content, contentLayout, showHidden);
  } else {
    children = content;
  }
  let renderOutput;
  const componentString = Component && Component.toString();
  const isIntentionalFragment = Component && (_includesInstanceProperty(componentString).call(componentString, 'react.fragment') || _includesInstanceProperty(componentString).call(componentString, 'React.Fragment'));
  if (isIntentionalFragment) {
    renderOutput = React.createElement(React.Fragment, {
      key: id
    }, children);
  } else if (isComponentUnresolved(Component)) {
    renderOutput = React.createElement(UnresolvedComponent, {
      id: id,
      componentName: Component
    });
  } else {
    const sanitizedProps = removeDangerousProps(componentProps);
    const props = _Object$assign(sanitizedProps, {
      resolvers: Component.isCodelessComponent ? sanitizedProps.resolvers : undefined
    });
    renderOutput = React.createElement(Component, _extends({
      id: key,
      key: key
    }, props), children);
  }
  if (selfLayout) {
    return renderLayout(renderOutput, selfLayout);
  }
  return renderOutput;
}
export function renderContent(contentMetadata, contentLayout, showHidden = false) {
  const content = _mapInstanceProperty(contentMetadata).call(contentMetadata, metadata => renderComponentFromMetadata(metadata, showHidden));
  if (!isEmpty(contentLayout)) {
    return renderLayout(content, contentLayout);
  }
  return content;
}
export function renderLayout(content, contentLayout) {
  const LayoutComponent = contentLayout.component,
    componentProps = contentLayout.componentProps;
  if (LayoutComponent) {
    return React.createElement(LayoutComponent, removeDangerousProps(componentProps), content);
  }
  return content;
}
export function renderContentFromMetadata(contentMetadata, overrideProps, resolvers, showHidden = false) {
  const _prepareContentFromMe = prepareContentFromMetadata(contentMetadata, overrideProps, resolvers, contentMetadata),
    content = _prepareContentFromMe.content,
    _prepareContentFromMe2 = _prepareContentFromMe.contentLayout,
    contentLayout = _prepareContentFromMe2 === void 0 ? {} : _prepareContentFromMe2;
  return renderContent(content, contentLayout, showHidden);
}
export function validateMetadata(metadata, onValidationFailure) {
  const validationResult = schemaValidator.validate(metadata);
  if (!validationResult.valid) {
    if (onValidationFailure) {
      onValidationFailure('Metadata validation failed', 'warning');
    }
    log.warning("Metadata is invalid:\nFor easier debugging consider opening in an IDE (VSCode or Intellij):\n".concat(_JSON$stringify(validationResult.errorMessages)));
  }
}
export function findComponentFromMetadata(metadata, filterFn, skipHidden = true, list = []) {
  if (!metadata) {
    return list;
  }
  const component = metadata.component,
    componentProps = metadata.componentProps,
    content = metadata.content;
  const _ref5 = componentProps || {},
    value = _ref5.value,
    visible = _ref5.visible;
  if (skipHidden && visible === false) {
    return list;
  }
  if (!filterFn || filterFn(metadata)) {
    list.push(metadata);
  }
  if (isArray(content)) {
    if (skipHidden && component && component.isContentVisible) {
      const isContentVisible = component.isContentVisible(value, componentProps);
      if (!isContentVisible) {
        return list;
      }
    }
    findContentFromMetadata(content, filterFn, skipHidden, list);
  }
  return list;
}
export function findContentFromMetadata(contentMetadata, filterFn, skipHidden = true, list = []) {
  const contentArray = getContentArray(contentMetadata);
  return _reduceInstanceProperty(contentArray).call(contentArray, (foundArray, item) => findComponentFromMetadata(item, filterFn, skipHidden, foundArray), list);
}
export function resolveContent(metadata, {
  resolveContent: contentResolver,
  resolveContentOptions
} = {}) {
  var _context7;
  if (!contentResolver && !resolveContentOptions) {
    return metadata.content;
  }
  const content = _reduceInstanceProperty(_context7 = resolveContentOptions || ['content']).call(_context7, (resolvedContent, path) => resolvedContent || get(metadata, path), undefined);
  return contentResolver && contentResolver(content) || content;
}
export const isComponentUnresolved = Component => Component === undefined || Component === null || isString(Component) && !(isSupportedHTMLElement(Component) || isSupportedHTMLContainer(Component));
export function findComponentPropsById(meta, id) {
  if ((meta === null || meta === void 0 ? void 0 : meta.id) === id) {
    return (meta === null || meta === void 0 ? void 0 : meta.componentProps) || null;
  }
  const content = meta === null || meta === void 0 ? void 0 : meta.content;
  if (_Array$isArray(content)) {
    for (const metaItem of content) {
      const foundItem = findComponentPropsById(metaItem, id);
      if (foundItem) {
        return foundItem;
      }
    }
  }
  return null;
}